import React, { useRef, useCallback, useMemo, useEffect } from 'react';
import FileConstants from '../../../FileConstants'
import ENVIRONMENT from '../../../environments';

const CUSTOMER_USERNAME = FileConstants.CUSTOMER_USERNAME;

const AiSceneCreatorIframe = ({ location }) => {
  const iframeRef = useRef(null);
  const iframeSrc = useMemo(() => {
    const baseUrl = ENVIRONMENT.AI_SCENE_CREATOR_URL || 'https://darpit0wkkhwg.cloudfront.net/';
    const search = location?.search || '';
    if (!search) return baseUrl;

    const separator = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${separator}${search.replace(/^\?/, '')}`;
  }, [location?.search]);

  const sendUsernameToIframe = useCallback((targetOrigin) => {
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return;

    try {
      const origin = targetOrigin != null ? targetOrigin : new URL(iframeSrc).origin;
      iframe.contentWindow.postMessage(
        {
          username: CUSTOMER_USERNAME,
          customerUsername: CUSTOMER_USERNAME,
          company_id: localStorage.getItem('company_id')
        },
        origin
      );
    } catch (_) {
      // Invalid URL or postMessage failed
    }
  }, [iframeSrc]);

  useEffect(() => {
    let bc;
    try {
      bc = new BroadcastChannel('ai_scene_render_channel');
    } catch (e) {
      // BroadcastChannel not supported
    }

    const handleMessage = (event) => {
      const data = event?.data;
      if (!data || typeof data !== 'object') return;

      if (data.type === 'SCENE_CREATOR_READY') {
        sendUsernameToIframe(event.origin);
        return;
      }

      if (data.type === 'request_token_refresh') {
        const iframe = iframeRef.current;
        if (!iframe?.contentWindow) return;
        try {
          iframe.contentWindow.postMessage(
            { token: localStorage.getItem('all3d_jwt_token') },
            event.origin
          );
        } catch (_) {}
        return;
      }

      if (data.type === 'AI_RENDER_REQUESTED' && bc) {
        const payload = data.payload != null ? data.payload : {
          camera_name: data.camera_name,
          sceneId: data.sceneId,
          taskId: data.taskId,
          platform_request_id: data.platform_request_id,
        };
        console.log('AI_SCENE_RENDER_REQUESTED', payload);
        bc.postMessage({ type: 'AI_SCENE_RENDER_REQUESTED', payload });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
      if (bc) bc.close();
    };
  }, [sendUsernameToIframe]);

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        ref={iframeRef}
        title="AI Scene Creator"
        src={iframeSrc}
        style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
        allowFullScreen
      />
    </div>
  );
};

export default AiSceneCreatorIframe;